import {
    FaHandsHelping,
    FaUserTie,
    FaUsers,
    FaTasks,
    
} from "react-icons/fa"
import "./UniversityNSS.css"
import Navbar from "../../Navbar/Navbar"
import Footer from "../../Footer/Footer"

const UniversityNSS = () => {
    return (
        <>
            <Navbar />

            {/* ================= BANNER ================= */}
            <div className="nss-banner">
                <img
                    src="/campuslife/nss/nss-banner.jpeg"
                    alt="Rayalaseema University NSS"
                />
                <div className="nss-banner-overlay">
                    <h1>National Service Scheme (NSS)</h1>
                    <p>Rayalaseema University, Kurnool</p>
                </div>
            </div>

            <section className="nss-section">
                <div className="nss-container">

                    {/* ================= ABOUT ================= */}
                    <div className="nss-about">
                        <h2><FaHandsHelping /> About NSS</h2>
                        <p>
                            The National Service Scheme (NSS) at Rayalaseema University aims
                            to develop student personality through community service.
                            NSS provides opportunities for students to engage in social
                            service, environmental protection, health awareness and
                            nation-building activities.
                        </p>
                        <p>
                            Through regular activities and special camps, NSS inculcates
                            values of discipline, leadership, social responsibility and
                            national integration among student volunteers.
                        </p>
                    </div>

                    {/* ================= COORDINATOR ================= */}
                    <div className="nss-coordinator">
                        <h2><FaUserTie /> NSS Coordinator</h2>

                        <div className="nss-coordinator-card">
                            <img
                                src="/botany/kavitha.JPG"
                                alt="Dr. B. Kavitha"
                            />

                            <div className="nss-coordinator-info">
                                <h3>Dr.B.Kavitha</h3>
                                <p className="designation">NSS Programme Coordinator</p>
                                <p>Rayalaseema University, Kurnool</p>

                                <p><strong>Phone:</strong> 7981750450</p>
                                <p><strong>Email:</strong> ruknlnss@gmail.com</p>
                            </div>
                        </div>
                    </div>

                    {/* ================= NSS UNITS & VOLUNTEER STRENGTH ================= */}
                    <div className="nss-units">
                        <h2><FaUsers /> NSS Units & Volunteer Strength</h2>

                        <div className="nss-units-grid">

                            {/* Unit – II */}
                            <div className="nss-unit-card">
                                <img
                                    src="/botany/venkataramanabotony.JPG"
                                    alt="Dr. K. Venkata Ratnam"
                                    className="nss-officer-img"
                                />
                                <h3>NSS Unit – II</h3>
                                <p><strong>Programme Officer</strong> <br />Dr. K. Venkata Ratnam</p>
                                {/* <p><strong>Phone:</strong> 9XXXXXXXXX</p>
                <p><strong>Email:</strong> kvratnam@rayalaseemauniversity.ac.in</p> */}
                                <p><strong>Volunteers:</strong> 100</p>
                            </div>

                            {/* Unit – III */}
                            <div className="nss-unit-card">
                                <img
                                    src="/zoology/bandela.JPG"
                                    alt="Dr. B. Vijayudu"
                                    className="nss-officer-img"
                                />
                                <h3>NSS Unit – III</h3>
                                <p><strong>Programme Officer</strong><br />Dr. B. Vijayudu</p>
                                {/* <p><strong>Phone:</strong> 9XXXXXXXXX</p>
                <p><strong>Email:</strong> bvijayudu@rayalaseemauniversity.ac.in</p> */}
                                <p><strong>Volunteers:</strong> 100</p>
                            </div>

                            {/* Unit – IV */}
                            <div className="nss-unit-card">
                                <img
                                    src="/hs/nagachandrudu.JPG"
                                    alt="Dr. S. Nagachandrudu"
                                    className="nss-officer-img"
                                />
                                <h3>NSS Unit – IV</h3>
                                <p><strong>Programme Officer</strong> <br />Dr. S. Nagachandrudu</p>
                                {/* <p><strong>Phone:</strong> 9XXXXXXXXX</p>
                <p><strong>Email:</strong> snagachandrudu@rayalaseemauniversity.ac.in</p> */}
                                <p><strong>Volunteers:</strong> 100</p>
                            </div>

                            {/* Unit – V */}
                            <div className="nss-unit-card">
                                <img
                                    src="/mechanics/shivaprasad.JPG"
                                    alt="B. V. Siva Prasad Reddy"
                                    className="nss-officer-img"
                                />
                                <h3>NSS Unit – V</h3>
                                <p><strong>Programme Officer</strong> <br />B. V. Siva Prasad Reddy</p>
                                {/* <p><strong>Phone:</strong> 9XXXXXXXXX</p>
                <p><strong>Email:</strong> sivaprasad@rayalaseemauniversity.ac.in</p> */}
                                <p><strong>Volunteers:</strong> 100</p>
                            </div>

                        </div>

                        <div className="nss-total-strength">
                            <h4>
                                Total NSS Volunteer Strength:
                                <span> 400</span>
                            </h4>
                        </div>
                    </div>

                    {/* ================= NSS PROGRAMMES & ACTIVITIES ================= */}
                    <div className="nss-programmes">
                        <h2><FaTasks /> NSS Programmes & Activities</h2>

                        <p className="nss-programme-intro">
                            The NSS units of Rayalaseema University conducted various programmes during
                            the academic year to promote social responsibility, community service,
                            environmental awareness, and national integration among students.
                        </p>

                        <div className="nss-activities-list">

                            <div className="nss-activity-card">
                                <h4>Savitribai Phule Jayanthi Celebrations</h4>
                                <p><strong>Date:</strong> 03 January 2026</p>
                            </div>

                            <div className="nss-activity-card">
                                <h4>NSS Special Camps</h4>
                                <p><strong>Academic Year:</strong> 2025–26</p>
                            </div>

                            <div className="nss-activity-card">
                                <h4>Clean & Green Drive (Every 3rd Saturday)</h4>
                                <p><strong>Date:</strong> 20 December 2025</p>
                            </div>

                            <div className="nss-activity-card">
                                <h4>Har Ghar Tiranga Campaign</h4>
                                <p><strong>Duration:</strong> 01 – 15 August 2025</p>
                            </div>

                            <div className="nss-activity-card">
                                <h4>Medical Camp</h4>
                                <p><strong>Date:</strong> 24 July 2025</p>
                            </div>

                            <div className="nss-activity-card">
                                <h4>Swachha Andhra – Plantation & Plastic Collection Drive</h4>
                                <p><strong>Date:</strong> 19 July 2025</p>
                            </div>

                            <div className="nss-activity-card">
                                <h4>International Yoga Day</h4>
                                <p><strong>Date:</strong> 26 June 2025</p>
                            </div>

                            <div className="nss-activity-card">
                                <h4>Swachha Andhra (Clean & Green Programme)</h4>
                                <p><strong>Date:</strong> 24 May 2025</p>
                            </div>

                            <div className="nss-activity-card">
                                <h4>Babu Jagjevan Rao Birthday Celebrations</h4>
                                <p><strong>Date:</strong> 04 April 2025</p>
                            </div>

                        </div>
                    </div>


                    {/* ================= GALLERY ================= */}
                    <div className="nss-gallery">
                        <h2>NSS Activities Gallery</h2>

                        <div className="gallery-grid">
                            <img src="/campuslife/nss/nss2.jpg" alt="NSS Activity 2" />
                            <img src="/campuslife/nss/nss3.jpg" alt="NSS Activity 3" />
                            <img src="/campuslife/nss/nss6.jpg" alt="NSS Activity 6" />
                            <img src="/campuslife/nss/nss9.jpg" alt="NSS Activity 9" />
                            <img src="/campuslife/nss/nss16.jpg" alt="NSS Activity 16" />
                            <img src="/campuslife/nss/nss20.jpg" alt="NSS Activity 20" />
                            <img src="/campuslife/nss/nss21.jpg" alt="NSS Activity 21" />
                            <img src="/campuslife/nss/nss23.jpg" alt="NSS Activity 23" />
                            <img src="/campuslife/nss/nss24.jpg" alt="NSS Activity 24" />
                            <img src="/campuslife/nss/nss27.jpg" alt="NSS Activity 27" />
                            <img src="/campuslife/nss/nss28.jpg" alt="NSS Activity 28" />
                            <img src="/campuslife/nss/nss29.jpg" alt="NSS Activity 29" />
                            <img src="/campuslife/nss/nss30.jpg" alt="NSS Activity 30" />
                            <img src="/campuslife/nss/nss31.jpg" alt="NSS Activity 31" />
                            <img src="/campuslife/nss/nss32.jpg" alt="NSS Activity 32" />
                            <img src="/campuslife/nss/nss33.jpg" alt="NSS Activity 33" />
                            <img src="/campuslife/nss/nss34.jpeg" alt="NSS Activity 34" />
                            <img src="/campuslife/nss/nss35.jpeg" alt="NSS Activity 35" />
                            <img src="/campuslife/nss/nss36.jpeg" alt="NSS Activity 36" />
                            <img src="/campuslife/nss/nss37.jpeg" alt="NSS Activity 37" />
                            <img src="/campuslife/nss/nss38.jpeg" alt="NSS Activity 38" />
                            
                            <img src="/campuslife/nss/nss_a.jpg" alt="NSS Activity A" />
                            <img src="/campuslife/nss/nss_c.jpg" alt="NSS Activity C" />
                            <img src="/campuslife/nss/nss_d.jpg" alt="NSS Activity D" />
                        </div>

                    </div>

                </div>
            </section>

            <Footer />
        </>
    )
}

export default UniversityNSS
